<div class="login-container">

  <div class="login-panel">

    <div class="title-style">Welcome to ARM</div>

    <div class="login-detail">

      <td class="Username">
        <mat-form-field  floatLabel='never' class="username-field">
          <label for="username">Username</label>
          <input class="input-line"  matInput placeholder="" [(ngModel)]="credentials.username"
                 id="username" name="username" (keyup.enter)="login()" autocomplete="nope" required/>
        </mat-form-field>
       </td>

       <td class="password">
          <mat-form-field floatLabel='never' class="Password-field">
            <label for="password" >Password</label>
           <input class="input-line"  matInput placeholder="" [(ngModel)]="credentials.password"
               [type]="hidePassword ? 'password' : 'text'" id="password" name="password" (keyup.enter)="login()" autocomplete="nope" required>

            <button  class="visibility-button" matSuffix mat-icon-button aria-label="Clear" (click)="hidePassword = !hidePassword">
              <mat-icon matSuffix>{{hidePassword ? 'visibility' : 'visibility_off'}}</mat-icon>
            </button>

          </mat-form-field>
        </td>

      </div>

      <div class="error-style" *ngIf="errorMessage">
        <i class="fa fa-exclamation-circle"></i>
          {{errorMessage}}
      </div>


      <div class="buttons">

        <td class="azure-authentication">
          <ng-container *ngIf="isAzureEnabled" >
            <button type="button" mat-button (click)="navigateToMicrosoftLogin()" class="login-azure-button">
              <img src="assets/images/general/microsoft.svg" alt="Microsoft" class="microsoft-icon"/>
            Login with Microsoft
            </button>
          </ng-container>
        </td>

        <td>
          <button class="login-button" mat-button (click)="login()">Login</button>
        </td>

      </div>

    </div>

  <div class="logo-panel">
    <div class="flex-container">
      <div class="c1">
      </div>
      <div class="c2">

      </div>
    </div>


  </div>
</div>
